// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1v6JQ","left":"styles_left__1f7ek"};